import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { FilterItems } from './'

import '@loyal_molecules/accordion.css'
import { Icon, Input } from 'loyal-react'

import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion'

import 'react-accessible-accordion/dist/fancy-example.css'

class Filters extends Component {
  constructor (props) {
    super(props)

    this.state = {
      zipcode: null,
      mask: [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/
      ]
    }
  }

  handleUpdateZipcode = (e) => {
    this.setState({
      zipcode: e.target.value
    })
  }
  render () {
    const {
      categories,
      filterSelected,
      expanded,
      ordination
    } = this.props
    return (
      <Fragment>
        <Accordion
          className='container-filter row border-color-ui-3 radius'
          accordion={false}
        >
          {this.props.showZipCode ? (
            <AccordionItem
              expanded={expanded}
              className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
            >
              <AccordionItemTitle className='filter-accordion border-color-ui-3 col-12 px-0'>
                <button className='btn-accordion txt-left border-color-ui-3 txt-body-sm txt-uppercase-first'>
                  Localização
                  <Icon iconName='icon_down' />
                </button>
              </AccordionItemTitle>
              <AccordionItemBody className='panel-accordion border-top border-color-ui-3 bg-white  px-2 py-2'>
                <div className='filter-price col-12 px-0'>
                  <div className='row mx-0'>
                    <Input
                      id='cep'
                      label='CEP'
                      className='col-12 mb-1 has-content'
                      childrenClassName='has-content'
                      type='text'
                      mask={this.state.mask}
                      onBlur={this.handleUpdateZipcode}
                    />
                    <div className='col-12 mx-auto px-0'>
                      <button
                        role='button'
                        className='btn btn-sm btn-featured'
                        onClick={this.props.handleFilterChanged('zipcode')}
                        value={this.state.zipcode}
                        disabled={!this.state.zipcode}
                      >
                        Filtrar
                      </button>
                    </div>
                  </div>
                </div>
              </AccordionItemBody>
            </AccordionItem>
          ) : (
            ''
          )}
          <AccordionItem
            expanded={expanded}
            className={`filter-accordion filtered-accordion border-color-ui-3 col-12 px-0 d-none`}
          >
            <AccordionItemTitle className='filter-accordion border-color-ui-3 col-12 px-0'>
              <button
                className='btn-accordion txt-left border-color-ui-3 txt-body-sm txt-uppercase-first'
                aria-label={`Ordenar por`}
              >
                Ordenar por
                <Icon iconName='icon_down' />
              </button>
            </AccordionItemTitle>
            <AccordionItemBody
              className='panel-accordion border-top border-color-ui-3 bg-white  px-2 py-1'
              data-ordernation={ordination}
            >
              <div className='panel-scroll'>
                <div className='col-12 py-half'>
                  <a href='?sort=DISTANCE' className='txt-body-sm'>
                    Menor distância
                  </a>
                </div>
                <div className='col-12 py-half'>
                  <a href='?sort=HIGHERDISCOUNTS' className='txt-body-sm'>
                    Maior desconto
                  </a>
                </div>
              </div>
            </AccordionItemBody>
          </AccordionItem>

          <FilterItems
            expanded={expanded}
            items={categories}
            title='Categoria'
            type='category'
            handleFilterChanged={this.props.handleFilterChanged}
            filterSelected={filterSelected}
          />
        </Accordion>
      </Fragment>
    )
  }
}

// schema
Filters.propTypes = {
  categories: PropTypes.array,
  filterSelected: PropTypes.object,
  handleFilterChanged: PropTypes.func.isRequired,
  expanded: PropTypes.any,
  ordination: PropTypes.object,
  showZipCode: PropTypes.bool
}

export default Filters



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Filters/Filters.js